// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3PnSr","footer":"ModalFilter_footer__3qSBT"};